import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  item: {
    position: 'relative',
  },
  paper: {
    height: '100%',
    backgroundColor: '#fff',
    padding: theme.spacing(1.5),
    boxShadow: '0 4px 10px 0 rgb(0 0 0 / 7%)',

    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('sm')]: {
      minHeight: 100,
    },
  },
  paperHover: {
    transition: 'transform .2s',

    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  paperDisabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  title: {
    textTransform: 'uppercase',
    fontSize: 16,
    color: '#192542',
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: 14,
    color: '#7c7c7c',
  },
}));
